// extracted by mini-css-extract-plugin
export default {"root":"ButtonRedirect_root__zcWpq","placeHolderShimmer":"ButtonRedirect_placeHolderShimmer__DQt+T"};